import Vue from 'vue'
import moment from 'moment'
import VueMoment from 'vue-moment'
import store from '../store'

moment.locale(store.state.settings.currentLang)

Vue.use(VueMoment, { moment })
